// Three kinds of users model
export interface MemberState {
  id: string;
  videoCallStatus: VideoCallStatus;
}
export interface StudentState extends MemberState {
  index: number;
  name: string;
  englishName: string;
  avatar?: string;
  badge: number;
  raisingHand: boolean;
  isPalette: boolean;
}

export interface TeacherState extends MemberState {
  name: string;
  avatar: string;
  disconnectTime?: number | null;
}

export interface HelperState extends MemberState {
  name: string;
  avatar: string;
  isVideoShownByTeacher: boolean;
}

export interface LessonInfo {
  unit: string;
  lesson: string;
}

export enum VideoCallStatus {
  Disconnected = 0, // disconnected
  Joined = 2,
}

export enum StreamingStatus {
  WAITING = 0,
  CONNECTING = 1,
  CONNECTED = 2,
  DISCONNECTED = 3,
}

export interface UserIdPayload {
  id: string;
}
export interface UserMediaPayload {
  id: string;
  enable: boolean;
}
export interface IndependentStudentStatus {
  studentId: string;
  currentItemId: string;
}
export interface DeviceMediaPayload {
  enable: boolean;
}

export interface StudentBadgePayload {
  id: string;
  badge: number;
}

export type DefaultPayload = any;

export interface InitClassRoomPayload {
  classId: string;
  userId: string;
  userName: string;
  role: string;
  deviceId: string;
  isHelper?: boolean;
  groupId?: string;
  // callFirstTime is true when user join class for the first time, not from the reconnection
  callFirstTime: boolean;
}

export interface NetworkQualityPayload {
  uplinkNetworkQuality: number;
  downlinkNetworkQuality: number;
}

export interface ParamsToJoinCurSessionInterface {
  deviceId: string;
  groupId: string;
}

export const SHOW_LOW_BANDWIDTH_NOTIFICATION_DURATION = 10; //10s

export interface PencilPayloadInterface {
  size: number;
  color: string;
}

export interface ShapePayloadInterface {
  userId: string;
  brushstrokes: string[];
}

export interface FabricPayloadInterface {
  fabricId: string;
  fabricData: string;
}

export interface PositionPayloadInterface {
  x: number;
  viewportX?: number;
  y: number;
  viewportY?: number;
}
export interface OneToOneModeResponse {
  // Student's id who enter or exit the one-to-one mode
  studentOneToOneId: string;
  // True if the student enters the one-to-one mode, false if the student exits the one-to-one mode
  enable: boolean;
}

export interface RequestSetExposureItem {
  exposureItemId: string;
  exposureId: string;
}

export interface OnTeacherSetLessonPlanItemContent extends RequestSetExposureItem {
  timestamp: number;
}
